<template>
  <BasicLayout>
    <template #wrapper>
      <el-card class="box-card">

        <el-form ref="queryForm" :model="queryParams" :inline="true">
          <el-form-item label="用户类型" prop="loginPlat">
            <el-select v-model="queryParams.uid2" placeholder="请选择">
              <el-option
                v-for="item in userType"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="开始日期" prop="startDate">
            <el-date-picker
              v-model="queryParams.startDate"
              type="date"
              placeholder="选择日期"
              value-format="yyyy-MM-dd"
              @keyup.enter.native="handleQuery"
            />
          </el-form-item>
          <el-form-item label="结束日期" prop="startDate">
            <el-date-picker
              v-model="queryParams.endDate"
              type="date"
              placeholder="选择日期"
              value-format="yyyy-MM-dd"
              @keyup.enter.native="handleQuery"
            />
          </el-form-item>
          <el-form-item label="用户ID" prop="type">
            <el-input
              v-model.number="queryParams.uid"
              placeholder="请输入用户ID"
              clearable
              size="small"
              @keyup.enter.native="handleQuery"
            />
          </el-form-item>

          <el-form-item label="版本" prop="version">
            <el-select v-model="queryParams.version" filterable clearable style="width: 110px" placeholder="请选择">
              <el-option
                v-for="item in versionArr"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>

          <el-form-item label="平台" prop="loginPlat">
            <el-select v-model="queryParams.loginPlat" style="width: 110px" placeholder="请选择">
              <el-option
                v-for="item in plat"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>

          <el-form-item>
            <el-button type="primary" :loading="loading" icon="el-icon-search" size="mini" @click="handleQuery">查询</el-button>
            <!--            <el-button icon="el-icon-refresh" size="mini" @click="resetQuery">重置</el-button>-->
            <el-button type="success" icon="el-icon-refresh" :loading="loading" size="mini" @click="exportData">导出</el-button>
          </el-form-item>
        </el-form>

        <div slot="header" class="clearfix">
          <span>用户列表</span>
        </div>

        <el-table
          :data="tableData"
          border
          style="width: 100%;"
          :header-cell-class-name="handleHeaderClass"
          @header-click="handleHeaderCLick"
          @sort-change="handleTableSort"
        >
          <el-table-column
            prop="mid"
            label="用户ID"
            sortable="custom"
            align="center"
          >
            <template v-slot:default="scope">
              <a alt="用户流水" style="color: #0e6cff" href="javascript:" @click="actUid(scope.row.mid)">{{ scope.row.mid }}</a>
            </template>
          </el-table-column>
          <el-table-column
            prop="user"
            label="用户类型"
            align="center"
          >
            <template v-slot:default="scope">
              <span v-if="scope.row.user.isFb === true"> FB</span>
              <span v-else>游客</span>
            </template>
          </el-table-column>

          <el-table-column
            prop="user"
            label="平台"
            align="center"
          >
            <template v-slot:default="scope">
              <span v-if="scope.row.user.login_plat === 1"> 安卓</span>
              <span v-else-if="scope.row.user.login_plat === 3"> TG</span>
              <span v-else>苹果</span>
            </template>
          </el-table-column>

          <el-table-column
            prop="user.nick"
            label="昵称"
            align="center"
          />
          <el-table-column
            prop="user.email"
            label="邮箱"
            align="center"
          />

          <el-table-column
            prop="levelId"
            label="等级"
            sortable="custom"
            align="center"
          />

          <el-table-column
            prop="source"
            label="来源"
            align="center"
          />

          <el-table-column
            prop="user.price"
            label="充值"
            align="center"
          />

          <el-table-column
            prop="user.star"
            label="星星数"
            sortable="custom"
            align="center"
          />

          <el-table-column
            prop="user.money"
            label="金币"
            sortable="custom"
            align="center"
          />

          <el-table-column
            prop="user.spins"
            label="体力"
            sortable="custom"
            align="center"
          />

          <el-table-column
            prop="user.diamond"
            label="钻石"
            sortable="custom"
            align="center"
          />

          <el-table-column
            prop="user.beastCoin"
            label="野兽币"
            sortable="custom"
            align="center"
          />

          <el-table-column
            prop="user.createtime"
            label="注册国家"
            align="center"
          >
            <template v-slot:default="scope">
              {{ getCountry(scope.row.address.country_code) }}
            </template>
          </el-table-column>

          <el-table-column
            prop="user.loginTime"
            label="在线时长(分)"
            align="center"
          />

          <el-table-column
            prop="user.createtime"
            label="注册时间"
            align="center"
          />

          <el-table-column
            prop="user.lasttime"
            label="最后登录时间"
            align="center"
          />

          <el-table-column
            label="操作"
          >
            <template v-slot:default="scope">
              <el-button type="text" size="small" @click="actUid(scope.row.mid)">操作</el-button>
            </template>
          </el-table-column>
        </el-table>

        <pagination
          v-show="total>0"
          background
          :page.sync="queryParams.pageIndex"
          :limit.sync="queryParams.pageSize"
          :total="total"
          @pagination="getTables({})"
        />
      </el-card>
    </template>
  </BasicLayout>
</template>

<script>
import { exportUserList, getUserList } from '@/api/user/user_info'
import { getCacheQuery, setCacheQuery } from '@/utils'
export default {
  name: 'UserList',
  data() {
    return {
      countryMap: {},
      total: 0,
      loading: false,
      queryParams: {
        pageIndex: 1,
        pageSize: 10,
        uid2: 1,
        uid: '',
        order: '',
        startDate: '',
        endDate: '',
        loginPlat: '',
        version: ''
      },
      versionArr: [],
      ordersList: [],
      tableData: [],
      plat: [{ label: '所有', value: '' }, { label: '安卓', value: 1 }, { label: '苹果', value: 2 }, { label: 'TG', value: 3 }],
      userType: [{ label: '注册', value: 1 }, { label: '活跃', value: 2 }]
    }
  },
  created() {
    // let uid = this.$route.query.id
    this.getTables(undefined)
  },
  methods: {
    getCountry(country) {
      if (!country) {
        return '-'
      }
      if (this.countryMap[country]) {
        return this.countryMap[country]
      }
      return '-'
    },
    actUid(uid) {
      this.$router.push({ name: 'User', query: { uid: uid }})
    },
    handleQuery() {
      const uid = this.queryParams.uid
      if (isNaN(uid)) {
        this.msgError('用户UID有误！')
        return
      }

      if (this.queryParams.startDate || this.queryParams.endDate) {
        if (!this.queryParams.startDate) {
          this.msgError('请选择开始日期')
          return
        }
        if (!this.queryParams.endDate) {
          this.msgError('请选择结束日期')
          return
        }
        if (this.queryParams.startDate > this.queryParams.endDate) {
          this.msgError('开始日期不能大于结束日期')
          return
        }
      }

      this.getTables({})
    },
    resetQuery() {
      this.queryParams.uid = ''
      this.resetForm('queryForm')
      this.handleQuery()
    },
    getTables(event) {
      this.queryParams = getCacheQuery(this.$options.name, this.queryParams, event)
      this.loading = true
      getUserList(this.queryParams).then(res => {
        setCacheQuery(this.$options.name, this.queryParams)
        if (res.code === 200) {
          this.versionArr = []
          this.loading = false
          this.tableData = res.data.list.data
          this.total = res.data.count
          this.countryMap = res.data.list.countryMap
          this.queryParams.startDate = res.data.list.req.StartDate
          this.queryParams.endDate = res.data.list.req.EndDate
          if (res.data.list.version.length) {
            for (const i in res.data.list.version) {
              const val = res.data.list.version[i]
              this.versionArr.push({ label: val, value: val })
            }
          }
        } else {
          this.msgError(res.msg)
        }
      })
    },
    handleHeaderClass({ column }) {
      column.order = column.multiOrder
    },
    handleHeaderCLick(column) {
      if (column.sortable !== 'custom') {
        return
      }
      if (!column.multiOrder) {
        column.multiOrder = 'descending'
      } else if (column.multiOrder === 'descending') {
        column.multiOrder = 'ascending'
      } else {
        column.multiOrder = ''
      }
      this.handleOrderChange(column.property, column.multiOrder)
    },
    handleOrderChange(orderColumn, orderState) {
      const result = this.ordersList.find(e => e.orderColumn === orderColumn)
      if (result) {
        result.orderState = orderState
      } else {
        this.ordersList.push({
          orderColumn: orderColumn,
          orderState: orderState
        })
      }
      // this.getDataList()
      for (const i in this.ordersList) {
        const val = this.ordersList[i]
        switch (val.orderColumn) {
          case 'user.spins':
            this.ordersList[i].orderColumn = 'gh_gameinfo.spins'
            break
          case 'user.money':
            this.ordersList[i].orderColumn = 'gh_gameinfo.money'
            break
          case 'user.star':
            this.ordersList[i].orderColumn = 'gh_gameinfo.star'
            break

          case 'user.diamond':
            this.ordersList[i].orderColumn = 'gh_gameinfo.diamond'
            break

          case 'user.beastCoin':
            this.ordersList[i].orderColumn = 'gh_gameinfo.beast_coin'
            break
        }
      }
      if (this.ordersList.length > 0) {
        this.queryParams.order = JSON.stringify(this.ordersList)
        this.handleQuery()
      }
    },
    handleTableSort({ column, prop, order }) {
      // 有些列不需要排序，提前返回
      if (column.sortable !== 'custom') {
        return
      }
      if (!column.multiOrder) {
        column.multiOrder = 'descending'
      } else if (column.multiOrder === 'descending') {
        column.multiOrder = 'ascending'
      } else {
        column.multiOrder = ''
      }

      this.handleOrderChange(column.property, column.multiOrder)
    },
    dateToCreate(col, row, val) {
      if (col.user.Lasttime1 > 0) {
        var date = new Date(col.user.createtime1 * 1000)
        return date.toLocaleString()// 将时间戳转换为Date对象
      }
      return '-'
    },
    dateToLastTime(col, row, val) {
      if (col.user.Lasttime1 > 0) {
        var date = new Date(col.user.Lasttime1 * 1000)
        return date.toLocaleString()// 将时间戳转换为Date对象
      }
      return '-'
    },
    exportData() {
      if (!this.queryParams.startDate) {
        this.msgError('请选择开始日期')
        return
      }
      if (!this.queryParams.endDate) {
        this.msgError('请选择结束日期')
        return
      }
      if (this.queryParams.startDate > this.queryParams.endDate) {
        this.msgError('开始日期不能大于结束日期')
        return
      }
      this.loading = true
      exportUserList(this.queryParams).then(res => {
        if (res.code === 200) {
          this.loading = false
          this.msgSuccess(res.msg)
          this.godown()
        } else {
          this.msgError(res.msg)
        }
      })
    },
    godown() {
      setTimeout(() => {
        this.$router.push({ path: '/config/export-file/index' })
      }, 500)
    }
  }
}
</script>

<style scoped>
</style>
